<script setup lang="ts">
import { useField, useForm } from 'vee-validate';
import { object, string } from 'zod';
import { toTypedSchema } from '@vee-validate/zod';
import type { ReportReason } from '@/gql/graphql';
import type { AppSelectItem } from '@glow/shared/types/ui/AppSelect';

export type ReportCreateModalResult = {
  reason: ReportReason;
  text: string;
};
const emit = defineEmits<{
  (e: 'done', result: ReportCreateModalResult): void;
}>();

const validationSchema = toTypedSchema(
  object({
    reason: string(),
    text: string().min(15).max(512),
  })
);
const { handleSubmit } = useForm({ validationSchema });
const { value: reason, errorMessage: reasonError } = useField<string>('reason');
const { value: text, errorMessage: textError } = useField<string>('text');

const onSubmit = handleSubmit((values) => {
  emit('done', values as ReportCreateModalResult);
});

const reasonItems: AppSelectItem<ReportReason>[] = [
  {
    title: 'Мошенничество',
    value: 'Fraud',
  },
  {
    title: 'Непреемлимый контент',
    value: 'InappropriateContent',
  },
  {
    title: 'Оскорбительный контент',
    value: 'Offense',
  },
];
</script>

<template>
  <AppModal
    title="Пожаловаться"
    subtitle="Мы с удовольствием поможем вам решить проблему"
  >
    <form class="d-flex flex-column gap-3" @submit.prevent="onSubmit">
      <AppSelect
        v-model="reason"
        :items="reasonItems"
        placeholder="Причина"
        :error="!!reasonError"
      >
        <template #helper-text>{{ reasonError }}</template>
      </AppSelect>
      <AppInput
        v-model="text"
        placeholder="Текст"
        multiline
        counter
        :error="!!textError"
        :rows="5"
        :max-length="512"
      >
        <template #helper-text>{{ textError }}</template>
      </AppInput>
      <AppButton type="submit" fluid>Отправить</AppButton>
    </form>
  </AppModal>
</template>
